import React from 'react';
import Button from '../Button/Button';
import './ErreurPopUp.css';

interface ErreurPopUpProps {
  isOpen: boolean;
  title?: string;  
  message: string;
  onClose: () => void;
  buttonLabel?: string;
  details?: string;
}

const ErreurPopUp: React.FC<ErreurPopUpProps> = ({
  isOpen,
  title = "Erreur",  
  message = "Une erreur est survenue. Veuillez réessayer plus tard.",
  onClose,
  buttonLabel = "Fermer",
  details
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="erreur-popup">
        <div className="erreur-popup-header">
          <div className="erreur-popup-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 8V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="12" cy="16" r="1" fill="currentColor"/>
            </svg>
          </div>
          <h2>{title}</h2>
          <button className="erreur-popup-close" onClick={onClose}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
        
        <div className="erreur-popup-body">
          <p className="erreur-popup-message">{message}</p>
          
          {details && (
            <div className="erreur-popup-details">
              <details>
                <summary>Détails techniques</summary>
                <p>{details}</p>
              </details>
            </div>
          )}
        </div>
        
        <div className="erreur-popup-actions">
          <Button
            value={buttonLabel}
            variant="primary"
            onClick={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default ErreurPopUp;